import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60834e23"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "selected-text"
}
const _hoisted_2 = {
  key: 0,
  class: "person"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnimatedMelatiText = _resolveComponent("AnimatedMelatiText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "fade",
      onEnter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fadeTransitionEnded = true)),
      onLeave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fadeTransitionEnded = false))
    }, {
      default: _withCtx(() => [
        (_ctx.selected && _ctx.selected.type !== 'message')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["selected", { 'tour-active': _ctx.tourActive }])
            }, [
              _createVNode(_Transition, {
                name: _ctx.first ? 'slide-fade-large' : 'slide-fade'
              }, {
                default: _withCtx(() => [
                  (_ctx.fadeTransitionEnded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_ctx.selected.person)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.selected.person), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("h2", null, _toDisplayString(_ctx.selected.title), 1),
                        (_ctx.tourActive)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "outline-btn light",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openContent && _ctx.openContent(...args)))
                            }, "Lees het verhaal"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["name"])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.selected && _ctx.selected.type === 'message')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["selected message", { 'tour-active': _ctx.tourActive }])
            }, [
              (_ctx.selected.from || _ctx.selected.to)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["message-meta", { visible: _ctx.letterTransitionEnded }])
                  }, [
                    (_ctx.selected.from)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Melati van " + _toDisplayString(_ctx.selected.from) + " ", 1),
                          _hoisted_3
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.selected.to)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" voor " + _toDisplayString(_ctx.selected.to), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("h2", null, [
                _createVNode(_component_AnimatedMelatiText, {
                  text: _ctx.selected.title,
                  onStart: _cache[3] || (_cache[3] = () => (_ctx.letterTransitionEnded = false)),
                  onEnd: _cache[4] || (_cache[4] = () => (_ctx.letterTransitionEnded = true))
                }, null, 8, ["text"])
              ]),
              (_ctx.tourActive)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: _normalizeClass([{ visible: _ctx.letterTransitionEnded }, "message-btn outline-btn blue"]),
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openContent && _ctx.openContent(...args)))
                  }, " Lees meer ", 2))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}